<template>
  <div id="statistics">
    <Col class="demo-spin-col" span="8" v-show="loading">
      <Spin fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>数据分析中</div>
      </Spin>
    </Col>
    <div
      style="
        margin-left: 25px;
        margin-top: 10px;
        padding: 5px;
        text-align: left;
      "
    >
      统计类型：
      <Select v-model="selectSta" style="width: 100px; margin-right: 20px">
        <Option v-for="item in statisticsList" :value="item" :key="item">{{
          item
        }}</Option>
      </Select>
      <template v-if="selectSta == '按台风'">
        年份：
        <Select
          v-model="selectYear"
          style="width: 100px; margin-right: 20px"
          @on-change="changeYear"
        >
          <Option v-for="item in yearList" :value="item" :key="item">{{
            item
          }}</Option>
        </Select>

        台风选择：
        <Select
          v-model="selectTyphoon"
          style="width: 100px; margin-right: 20px"
          @on-change="changeTyphoon"
        >
          <Option
            v-for="item in typhoonList"
            :value="item.tfid"
            :key="item.tfid"
            >{{ item.name }}</Option
          >
        </Select>

        对比预报源：
        <Select
          v-model="selectYubaoType"
          style="width: 100px; margin-right: 20px"
        >
          <Option
            v-for="item in yubaoTypeList"
            :value="item.value"
            :key="item.value"
            >{{ item.name }}</Option
          >
        </Select>
      </template>

      <template v-if="selectSta == '按年'">
        年份：
        <Select
          v-model="selectYear"
          style="width: 100px; margin-right: 20px"
          @on-change="changeYear"
        >
          <Option v-for="item in yearList" :value="item" :key="item">{{
            item
          }}</Option>
        </Select>

        对比预报源：
        <Select
          v-model="selectYubaoType"
          style="width: 100px; margin-right: 20px"
        >
          <Option
            v-for="item in yubaoTypeList"
            :value="item.value"
            :key="item.value"
            >{{ item.name }}</Option
          >
        </Select>
      </template>

      标准差：
      <Select v-model="SD" style="width: 100px; margin-right: 20px">
        <Option :value="1.5">1.5</Option>
        <Option :value="2.0">2.0</Option>
      </Select>

      <button class="layui-btn layui-btn-normal" @click="getData" style="width: 100px; margin-right: 50px">
        对比分析
      </button>

      导出选择：
      <Select v-model="hourSpan" style="width: 100px; margin-right: 10px">
        <Option value="%%">全部</Option>
        <Option :value="24">24</Option>
        <Option :value="48">48</Option>
        <Option :value="72">72</Option>
      </Select>
      <button class="layui-btn layui-btn-normal" @click="exportTable">
        导出表格
      </button>
    </div>
    <Table
      :columns="columns"
      :data="analysisResult[selectYubaoType]"
      ref="analysisTable"
      width="100%"
      @on-select="remainRow"
      @on-select-cancel="remainRow"
      @on-select-all="remainRow"
    >
      <template slot-scope="{ row }" slot="time">
        {{ moment(row.time).format("YYYY-MM-DD HH:mm:ss") }}
      </template>
    </Table>
  </div>
</template>

<script type="text/ecmascript-6">
import moment from "moment";
import Weathermap from "@/map/weathermap.vue";
export default {
  components: {
    Weathermap,
  },
  data() {
    return {
      moment: moment,
      yearList: [],
      selectYear: Number(moment().format("YYYY")),
      statisticsList: ["按台风", "按年"],
      selectSta: "按台风",
      typhoonList: [],
      selectTyphoon: "",
      foreastingid: "",
      hourSpan: '%%',
      yubaoTypeList: [
        {
          name: "中大",
          value: "9",
        },
        {
          name: "中国",
          value: "1",
        },
        {
          name: "中国香港",
          value: "3",
        },
        {
          name: "中国台湾",
          value: "2",
        },
        {
          name: "广东",
          value: "4",
        },
        {
          name: "日本",
          value: "5",
        },
        {
          name: "美国",
          value: "6",
        },
        {
          name: "菲律宾",
          value: "7",
        },
        {
          name: "韩国",
          value: "8",
        },
      ],
      selectYubaoType: "9",
      // columns: [
      //   {
      //     type: "selection",
      //     width: 60,
      //     align: "center",
      //   },
      //   {
      //     title: "起报日期",
      //     key: "fdate",
      //     align: "center",
      //   },
      //   {
      //     title: "实况日期",
      //     key: "date",
      //     align: "center",
      //   },
      //   {
      //     title: "预报路径偏差(km)",
      //     key: "ybpc",
      //     align: "center",
      //   },
      //   {
      //     title: "压强偏差(hPa)",
      //     key: "pespc",
      //     align: "center",
      //   },
      //   {
      //     title: "风速偏差(m/s)",
      //     key: "windpc",
      //     align: "center",
      //   },
      //   {
      //     title: "对比经度",
      //     key: "lng",
      //     align: "center",
      //   },
      //   {
      //     title: "对比纬度",
      //     key: "lat",
      //     align: "center",
      //   },
      //   {
      //     title: "对比移动速度",
      //     key: "movespeed",
      //     align: "center",
      //   },
      //   {
      //     title: "对比风速",
      //     key: "speed",
      //     align: "center",
      //   },
      //   {
      //     title: "对比气压",
      //     key: "pressure",
      //     align: "center",
      //   },
      //   {
      //     title: "中大经度",
      //     key: "lng1",
      //     align: "center",
      //   },
      //   {
      //     title: "中大纬度",
      //     key: "lat1",
      //     align: "center",
      //   },
      //   {
      //     title: "中大移动速度",
      //     key: "movespeed1",
      //     align: "center",
      //   },
      //   {
      //     title: "中大风速",
      //     key: "speed1",
      //     align: "center",
      //   },
      //   {
      //     title: "中大气压",
      //     key: "pressure1",
      //     align: "center",
      //   },
      // ],
      columns: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        // },
        {
          title: "日期",
          key: "time",
          align: "center",
        },
        {
          title: "预报路径偏差(km)",
          key: "ybpc",
          align: "center",
        },
        {
          title: "压强偏差(hPa)",
          key: "pespc",
          align: "center",
        },
        {
          title: "风速偏差(m/s)",
          key: "windpc",
          align: "center",
        },
      ],
      result: {},
      analysisResult: {},
      selectionData: [],
      SD: 1.5,
      loading: false,
    };
  },
  mounted() {
    let t = this;
    for (let i = 0; i < 10; i++) {
      this.yearList.push(this.selectYear - i);
    }
    this.getTFBH(this.selectYear);
    setTimeout(function () {
      t.getData();
    }, 500);
  },
  watch: {},
  methods: {
    /**ajax请求数据  根据年份请求台风列表
     *@params year 年份
     **/
    getTFBH: function (year) {
      let t = this;
      //清除轨迹信息
      $.post(this.$ipConfig.getHisTyphoonData + "&starttime=" + year).then(
        (data2) => {
          if (data2.message === "查询成功") {
            t.typhoonList = data2.dataList;
            t.selectTyphoon = data2.dataList[0].tfid;
          } else {
            t.$Message.error({
              content: data.message,
              duration: 5,
            });
          }
        }
      );
    },
    changeYear() {
      this.getTFBH(this.selectYear);
    },
    changeTyphoon() {
      // this.getTyphoonTrack(this.selectTyphoon);
    },
    remainRow(selection, row) {
      this.selectionData = selection;
    },
    exportTable() {
      this.$refs.analysisTable.exportCsv({
        filename: "误差分析",
        columns: this.columns.filter((col, index) => index > 0),
        data: this.result.filter((data, index) => {
          //filter() 方法创建一个新的数组，新数组中的元素是通过检查指定数组中符合条件的所有元//素。
          for (let i = 0; i < this.selectionData.length; i++) {
            //比较对象是否相等
            if (this.compareObject(data, this.selectionData[i])) {
              console.log("Burning Test" + i);
              return true;
            }
          }
          return false;
        }),
      });
    },
    //比较对象是否相等的方法
    compareObject(obj1, obj2) {
      //Object.getOwnPropertyNames():方法返回一个指定对象所有自身属性的属性名（包括不可枚举属性但不包括Symbol值作为名称的属性）组成的数组。
      //对象内置属性方法:Object.keys()；该方法返回一个数组，数组内包括对象内可枚举属性以及方法名称。数组中属性名的排列顺序和使用 for...in 遍历该对象时返回的顺序一致。
      var attrs1 = Object.keys(obj1);
      var attrs2 = Object.keys(obj2);
      if (attrs1.length != attrs2.length) {
        return false;
      }
      for (var j = 0; j < attrs1.length; j++) {
        var attrNames = attrs1[j];
        if (obj1[attrNames] != obj2[attrNames]) {
          return false;
        }
      }
      return true;
    },
    getData() {
      let t = this;
      t.loading = true;
      if (this.selectSta == "按台风") {
        $.get(
          this.$ipConfig.getTyphoonWC +
            "getTyphoonAnyByTid&thisid=" +
            this.selectTyphoon
        ).then((data) => {
          let res = data.dataList;
          t.result = {};
          t.analysisResult = {};
          res.map((item) => {
            if (!t.result[item.source]) {
              t.result[item.source] = [];
            }
            item.date = moment(item.ftime).format("YYYY-MM-DD HH:mm:ss");
            item.fdate = moment(item.rtime).format("YYYY-MM-DD HH:mm:ss");
            t.result[item.source].push(item);
          });
          console.log(t.result);
          Object.keys(t.result).map((e) => {
            t.analysisResult[e] = [];
            let list24 = [],
              list48 = [],
              list72 = [];
            let obj = {};
            t.result[e].map((ev) => {
              if (!obj[ev.rtime]) {
                obj[ev.rtime] = [];
              }
              obj[ev.rtime].push(ev);
              if (ev.shici == 24) {
                list24.push(ev);
              } else if (ev.shici == 48) {
                list48.push(ev);
              } else if (ev.shici == 72) {
                list72.push(ev);
              }
            });
            Object.keys(obj).map((item) => {
              let arr = obj[item];
              let analysis24 = [];
              let analysis48 = [];
              let analysis72 = [];
              arr.map((m) => {
                if (m.shici == 24) {
                  analysis24.push(m);
                } else if (m.shici == 48) {
                  analysis48.push(m);
                } else if (m.shici == 72) {
                  analysis72.push(m);
                }
              });
              if (analysis24.length != 0) {
                let { sd, ave } = t.calcSD(list24);
                let handlerData = t.handleData(analysis24, sd, ave);
                handlerData.shici = 24;
                t.analysisResult[e].push(handlerData);
              }
              if (analysis48.length != 0) {
                let { sd, ave } = t.calcSD(list48);
                let handlerData = t.handleData(analysis48, sd, ave);
                handlerData.shici = 48;
                t.analysisResult[e].push(handlerData);
              }
              if (analysis72.length != 0) {
                let { sd, ave } = t.calcSD(list72);
                let handlerData = t.handleData(analysis72, sd, ave);
                handlerData.shici = 72;
                t.analysisResult[e].push(handlerData);
              }
            });
          });
          t.loading = false;
        });
      } else {
        $.get(
          this.$ipConfig.getTyphoonWC +
            "getTyphoonAnyByYears&starttime=" +
            this.selectYear +
            "&endtime=" +
            this.selectYear
        ).then((data) => {
          let res = data.dataList;
          t.analysisResult = {};
          let classifyTyphoonList = t.classifyTyphoon(res);

          Object.keys(classifyTyphoonList).map((item) => {
            let result = {};
            classifyTyphoonList[item].map((ev) => {
              if (!result[ev.source]) {
                result[ev.source] = [];
              }
              result[ev.source].push(ev);
            });
            Object.keys(result).map((e) => {
              if (!t.analysisResult[e]) t.analysisResult[e] = [];
              let list24 = [],
                list48 = [],
                list72 = [];
              result[e].map((ev) => {
                if (ev.shici == 24) {
                  list24.push(ev);
                } else if (ev.shici == 48) {
                  list48.push(ev);
                } else if (ev.shici == 72) {
                  list72.push(ev);
                }
              });
              if (list24.length != 0) {
                let { sd, ave } = t.calcSD(list24);
                let handlerData = t.handleData(list24, sd, ave);
                handlerData.shici = 24;
                t.analysisResult[e].push(handlerData);
              }
              if (list48.length != 0) {
                let { sd, ave } = t.calcSD(list48);
                let handlerData = t.handleData(list48, sd, ave);
                handlerData.shici = 48;
                t.analysisResult[e].push(handlerData);
              }
              if (list72.length != 0) {
                let { sd, ave } = t.calcSD(list72);
                let handlerData = t.handleData(list72, sd, ave);
                handlerData.shici = 72;
                t.analysisResult[e].push(handlerData);
              }
            });
          });
          Object.keys(t.analysisResult).map((item) => {
            let year24 = {
              ybpc: 0,
              pespc: 0,
              windpc: 0,
            };
            let year48 = {
              ybpc: 0,
              pespc: 0,
              windpc: 0,
            };
            let year72 = {
              ybpc: 0,
              pespc: 0,
              windpc: 0,
            };
            let len24 = 0;
            let len48 = 0;
            let len72 = 0;
            t.analysisResult[item].map((ev) => {
              if (ev.shici == 24) {
                year24.windpc -= -ev.windpc;
                year24.pespc -= -ev.pespc;
                year24.ybpc -= -ev.ybpc;
                len24++;
              } else if (ev.shici == 48) {
                year48.windpc -= -ev.windpc;
                year48.pespc -= -ev.pespc;
                year48.ybpc -= -ev.ybpc;
                len48++;
              } else if (ev.shici == 72) {
                year72.windpc -= -ev.windpc;
                year72.pespc -= -ev.pespc;
                year72.ybpc -= -ev.ybpc;
                len72++;
              }
            });
            t.analysisResult[item].push({
              time: this.selectYear + "年24小时偏差",
              windpc: (year24.windpc / len24).toFixed(2),
              pespc: (year24.pespc / len24).toFixed(2),
              ybpc: (year24.ybpc / len24).toFixed(2),
              shici: 24
            });
            t.analysisResult[item].push({
              time: this.selectYear + "年48小时偏差",
              windpc: (year48.windpc / len48).toFixed(2),
              pespc: (year48.pespc / len48).toFixed(2),
              ybpc: (year48.ybpc / len48).toFixed(2),
              shici: 48
            });

            t.analysisResult[item].push({
              time: this.selectYear + "年72小时偏差",
              windpc: (year72.windpc / len72).toFixed(2),
              pespc: (year72.pespc / len72).toFixed(2),
              ybpc: (year72.ybpc / len72).toFixed(2),
              shici: 72
            });
          });
          t.loading = false;
        });
      }
    },
    //计算平均数
    handleData(data, sd, ave) {
      let t = this;
      let obj = {};
      obj.time =
        moment(data[0].rtime).format("YYYY-MM-DD HH:mm:ss") +
        " " +
        data[0].shici +
        "小时" +
        "  " +
        data[0].tfid +
        " " +
        data[0].name;
      obj.ybpc = 0;
      obj.pespc = 0;
      obj.windpc = 0;

      let len = {
        ybpc: 0,
        pespc: 0,
        windpc: 0,
      };
      data.map((item) => {
        if (Math.abs(item.ybpc - ave.ybpc) / sd.ybpc <= t.SD * sd.ybpc) {
          obj.ybpc += item.ybpc;
          len.ybpc++;
        }

        if (Math.abs(item.pespc - ave.pespc) / sd.pespc < t.SD * sd.pespc) {
          obj.pespc += item.pespc;
          len.pespc++;
        }

        if (Math.abs(item.windpc - ave.windpc) / sd.windpc < t.SD * sd.windpc) {
          obj.windpc += item.windpc;
          len.windpc++;
        }
      });
      if (len.ybpc > 0) {
        obj.ybpc = (obj.ybpc / len.ybpc).toFixed(2);
      }
      if (len.pespc > 0) {
        obj.pespc = (obj.pespc / len.pespc).toFixed(2);
      }
      if (len.windpc > 0) {
        obj.windpc = (obj.windpc / len.windpc).toFixed(2);
      }
      return obj;
    },
    //按台风分类
    classifyTyphoon(res) {
      let arr = {};
      res.map((item) => {
        if (!arr[item.tfid]) {
          arr[item.tfid] = [];
        }
        item.date = moment(item.ftime).format("YYYY-MM-DD HH:mm:ss");
        item.fdate = moment(item.rtime).format("YYYY-MM-DD HH:mm:ss");
        arr[item.tfid].push(item);
      });
      return arr;
    },
    //计算标准差和均值
    calcSD(arr) {
      let sd = {
          ybpc: 0,
          pespc: 0,
          windpc: 0,
        },
        ave = {
          ybpc: 0,
          pespc: 0,
          windpc: 0,
        },
        sum = {
          ybpc: 0,
          pespc: 0,
          windpc: 0,
        },
        sums = {
          ybpc: 0,
          pespc: 0,
          windpc: 0,
        },
        len = arr.length;
        let pespcLen = 0;
      for (let i = 0; i < len; i++) {
        sum["ybpc"] += Number(arr[i]["ybpc"]);
      }
      ave["ybpc"] = sum["ybpc"] / len;
      for (let i = 0; i < len; i++) {
        sums["ybpc"] +=
          (Number(arr[i]["ybpc"]) - ave["ybpc"]) *
          (Number(arr[i]["ybpc"]) - ave["ybpc"]);
      }
      sd["ybpc"] = Math.sqrt(sums["ybpc"] / len).toFixed(4);

      for (let i = 0; i < len; i++) {
        if(Number(arr[i]["pespc"]) < 100){
          sum["pespc"] += Number(arr[i]["pespc"]);
          pespcLen++;
        }
      }
      ave["pespc"] = sum["pespc"] / pespcLen;
      for (let i = 0; i < len; i++) {
        if(Number(arr[i]["pespc"]) < 100){
          sums["pespc"] +=
          (Number(arr[i]["pespc"]) - ave["pespc"]) *
          (Number(arr[i]["pespc"]) - ave["pespc"]);
        }
      }
      sd["pespc"] = Math.sqrt(sums["pespc"] / pespcLen).toFixed(4);

      for (let i = 0; i < len; i++) {
        sum["windpc"] += Number(arr[i]["windpc"]);
      }
      ave["windpc"] = sum["windpc"] / len;
      for (let i = 0; i < len; i++) {
        sums["windpc"] +=
          (Number(arr[i]["windpc"]) - ave["windpc"]) *
          (Number(arr[i]["windpc"]) - ave["windpc"]);
      }
      sd["windpc"] = Math.sqrt(sums["windpc"] / len).toFixed(4);
      return { sd, ave };
    },
    exportTable() {
      let dic = [];
      let t = this;
      Object.keys(t.analysisResult).map((value) => {
        if (t.analysisResult[value].length > 0) {
          let name = t.yubaoTypeList.filter(item => item.value == value)[0].name;
          if(t.hourSpan == '%%'){
            dic.push({
              sheetName: name,
              col: this.columns,
              data: t.analysisResult[value],
            });
          }else{
            dic.push({
              sheetName: name,
              col: this.columns,
              data: t.analysisResult[value].filter(item => item.shici == this.hourSpan),
            });
          }

        }
      });
      let name = '误差分析数据';
      t.exportExcelPuls(dic, name);
    },
    // 导出表格(vue+iview,改良版)
    exportExcelPuls(dic, name) {
      /*
      参数格式及描述
      dic:[
    	{sheetName:"",col:[],data:[]},
        {sheetName:"",col:[],data:[]},
        {sheetName:"",col:[],data:[]},
        ...
        ]，分别为每页的表名，iview表格列的配置描述，请求到的数据
       name：字符串，导出的Excel文件名
      }
      */
      require.ensure([], () => {
        const { export_json_to_excel } = require("../common/export2Excel"); //这个地址和页面的位置相关，这个地址是 Export2Excel. js相对于页面的相对位置

        let tableData = [];
        dic.forEach((item, index) => {
          //整理数据
          tableData[index] = {};
          tableData[index]["sheetName"] = item.sheetName;
          tableData[index]["titles"] = [];
          tableData[index]["keys"] = [];
          for (var i = 0; i < item.col.length; i++) {
            if (item.col[i].slot) {
              tableData[index]["titles"].push(item.col[i].title);
              tableData[index]["keys"].push(item.col[i].slot);
              //如果有插槽，插槽名要和对应的key一样，如不一样需修改代码
            } else {
              if (item.col[i].children) {
                //判断是否有表头合并
                item.col[i].children.forEach((j) => {
                  tableData[index]["titles"].push(
                    item.col[i].title + "-" + j.title
                  );
                  tableData[index]["keys"].push(j.key);
                });
              } else {
                tableData[index]["titles"].push(item.col[i].title);
                tableData[index]["keys"].push(item.col[i].key);
              }
            }
          }
        });

        tableData.forEach((item, index) => {
          tableData[index]["data"] = this.formatJson(
            item.keys,
            dic[index].data
          );
          delete item.keys;
        });
        export_json_to_excel(tableData, name);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style scoped>
#item3 {
  width: 100%;
  height: 100%;
}
.layui-table-body {
  overflow-x: hidden;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  width: 100%;
  height: 100%;
  position: absolute;
  border: 1px solid #eee;
  z-index: 555;
}
</style>



// WEBPACK FOOTER //
// src/common/statistics.vue